<template>
  <div :class="['axiome-logique-container', 'axiome-logique-qualified-cardinality']">

    <!--Affichage OnProperty-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <template v-if="onPropertyBlanknodes.length">
        <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false" :braceDisplay="true"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>
    <!--Affichage Operand-->
    <span
      :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">exactly</span>


    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="qualifiedCardinalityLiterals" :leftMargin="false"
        :showLanguageBadge="showLanguageBadge" />
    </div>


    <!--Affichage onClass-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onClassLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <template v-if="onClassBlanknodes.length">
        <AttributeBlankNode :blankNodes="onClassBlanknodes" :leftMargin="false" :braceDisplay="true"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>
    <!--Affichage onDataRange-->

    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onDataRangeLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <template v-if="onDataRangeBlanknodes.length">
        <AttributeBlankNode :blankNodes="onDataRangeBlanknodes" :leftMargin="false" :braceDisplay="true"
          :showLanguageBadge="showLanguageBadge" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeQualifiedCardinality",
  computed: {
    qualifiedCardinalityLiterals() {
      let result = [];
      this.qualifiedCardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }
  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    qualifiedCardinality: {
      type: Array,
      default: () => []
    },
    onDataRangeLiterals: {
      type: Array,
      default: () => []
    },
    onDataRangeBlanknodes: {
      type: Array,
      default: () => []
    },
    onClassLiterals: {
      type: Array,
      default: () => []
    },
    onClassBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
